module.exports = __webpack_public_path__ + "img/sherbimet21_9.e2a59341.jpg";